import CryptoJS from 'crypto-js'

export function aeg45sa48ahbwegew(afsagvbs5ssv: string, asdv5a4dsv = ['gabghaedh54b4dae5gb', 'aegbdedbqhbwhbva56fagv', 'asfafwehgwrh564gehgqe']) {
  let rhhnr = ''
  asdv5a4dsv.forEach((vadsgvad) => {
    if (window) {
      const v = (window as any)?.[vadsgvad]
      if (v)
        rhhnr += v
    }
  })
  const fgagaegv = CryptoJS.enc.Utf8.parse(rhhnr)
  const gahgbr = CryptoJS.enc.Utf8.parse(afsagvbs5ssv)
  const encrypted = CryptoJS.AES.encrypt(gahgbr, fgagaegv, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}
